import { createAction } from 'redux-act'

export const checkToken = createAction('Check Token Request')
export const verifyToken = createAction('Verify Token Request')

export const tokenIsActive = createAction('Token is Active')

export const setSession = createAction('Set Session')
export const removeSession = createAction('Remove Session')
export const logoutRequest = createAction('Logout Request')
export const setLanguage = createAction('Set Language By Updated Language')

